import {isRouteErrorResponse, useRouteError} from "react-router-dom";


export default function ErrorPage() {
    const error = useRouteError();
    let errorMessage = ""
    console.log(error)
    if (isRouteErrorResponse(error)) {

        switch (error.status) {
            case 404:
                errorMessage = "404 - The appointment or page you are looking for cannot be found here";
                break;
            case 401:
                errorMessage = "401 - You aren't authorized to see this!";
                break;
            case 503:
                errorMessage = "503 - Our website is down and Josh is panicking. Try again in a little while.";
                break;
            case 418:
                errorMessage = "wut?";
                break;
            case 500:
            default:
                errorMessage = "500 - Something went wrong. I'm sorry dude.";
                break;
        }
    }
    return(
        <div className="error-page">
            <h1>Oops!</h1>
            <p>{errorMessage}</p>
        </div>
    )
}